class ComboProducts extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.submitButton = this.querySelector('.combo-products__footer button[type="submit"]');
    this.checkboxes = this.querySelectorAll("[data-variant-checkbox]");
    this.quantityInputs = this.querySelectorAll("[data-quantity-input]");
    this.quantityButtons = this.querySelectorAll("[data-quantity-button]");
    this.totalPrice = this.querySelector("[data-total-price]");
    this.originalPrice = this.querySelector("[data-original-price]");
    this.init();
  }

  init() {
    this.bindEvents();
    this.updateTotalPrice();
  }

  updateTotalPrice() {
    let total = 0;
    let original = 0;
    let shouldquantity = 0;
    const triggerSku = this.dataset.triggerSku;

    const checkboxes = this.querySelectorAll("[data-variant-checkbox]");

    const checkedBoxes = Array.from(checkboxes).filter((checkbox) => {
      return checkbox.checked;
    });
    let requiredQuantity = 0;
    const checkedBoxes2 = Array.from(checkboxes).filter((checkbox) => {
      if (checkbox.checked && checkbox.dataset.requiredDiscount == "true") {
        const quantity = parseInt(checkbox.closest(".combo-item").querySelector("[data-quantity-input]").value) || 1;
        requiredQuantity = Number(requiredQuantity) + Number(quantity);
        return true;
      }
      return false;
    });
    checkedBoxes.forEach((checkbox) => {
      if (checkbox.checked) {
        const price = parseFloat(checkbox.dataset.price / 100) || 0;
        const discount = parseFloat(checkbox.dataset.discount) || 0;
        const quantity = parseInt(checkbox.closest(".combo-item").querySelector("[data-quantity-input]").value) || 1;
        const sku = checkbox.dataset.sku;
        if (sku === triggerSku) {
          shouldquantity += parseInt(quantity);
        }
        if (requiredQuantity < 1) {
          total += price * quantity;
          original = total;
        } else {
          total += ((price * (100 - Number(discount))) / 100) * quantity;
          original += price * quantity;
        }
      }
    });
    if (parseInt(shouldquantity) > 0) {
      this.querySelector(".combo-products__gift-info").style.display = "block";
      this.querySelector(".combo-products__gift-quantity").innerHTML = " x" + parseInt(shouldquantity);
    } else {
      this.querySelector(".combo-products__gift-info").style.display = "none";
    }
    if (this.totalPrice) {
      this.totalPrice.textContent = `$${(Math.round(total * 100) / 100).toFixed(2)}`;
    }
    if (this.originalPrice) {
      if (total == original) {
        this.originalPrice.textContent = "";
        return;
      }
      this.originalPrice.textContent = `$${original.toFixed(2)}`;
    }
  }

  bindEvents() {
    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", () => this.updateTotalPrice());
    });

    this.quantityInputs.forEach((input) => {
      input.addEventListener("change", () => this.updateTotalPrice());
    });
    this.quantityButtons.forEach((button) => {
      button.addEventListener("click", () => this.updateTotalPrice());
    });
    // this.form.addEventListener('submit', this.handleSubmit.bind(this));
    this.submitButton.addEventListener("click", this.handleSubmit.bind(this));
  }

  async handleSubmit(event) {
    event.preventDefault();
    const newBotton = this.querySelector('.combo-products__footer button[type="submit"]');
    if (newBotton.getAttribute("aria-busy")) {
      return;
    }
    this.submitButton.setAttribute("disabled", true);
    this.submitButton.setAttribute("aria-busy", true);
    this.submitButton.style.pointerEvents = "none";
    let sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );
    let sections = sectionsToBundle.join(",");
    try {
      const items = this.getFormItems();

      let discountCode = this.dataset.discountCode;
      // console.log(discountCode, "discountCode");
      const colorstext = this.querySelectorAll(".combo-item__variant span") || "";
      // console.log(colorstext, "colorstext");
      colorstext.forEach((item) => {
        if (!item.className.includes("care") && item.textContent.includes(this.dataset.discountColor)) {
          discountCode = this.dataset.discountCodeColor || discountCode;
        }
      });
      if (discountCode) {
        await this.discountFetch(discountCode, items, sections);
      } else {
        this.addItemsToCart(items, sections);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  async discountFetch(discount_code, items, sections) {
    let that = this;
    await fetch("/discount/" + discount_code, {
      method: "GET",
    })
      .then(() => that.addItemsToCart(items, sections))
      .catch((error) => {
        console.error("折扣码应用失败:", error);
        // 即使折扣码失败也继续加购
        that.addItemsToCart(items, sections);
      });
  }
  async addItemsToCart(items, sections) {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: items,
        sections,
      }),
    });
    if (response.ok) {
      let responseJson = await response.json();
      let cartContent = await this.createCartPromise();
      cartContent["sections"] = responseJson["sections"];
      this.dispatchEvent(
        new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson["items"],
            cart: cartContent,
          },
        })
      );
      // // 触发购物车更改事件
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cartContent,
          },
        })
      );
      this.submitButton.removeAttribute("disabled");
      this.submitButton.removeAttribute("aria-busy");
      this.submitButton.style.pointerEvents = "auto";
    } else {
      this.submitButton.removeAttribute("disabled");
      this.submitButton.removeAttribute("aria-busy");
      this.submitButton.style.pointerEvents = "auto";
      throw new Error("Failed to add items to cart");
    }
  }
  createCartPromise = () => {
    return new Promise(async (resolve) => {
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();

      resolve(cartContent);
    });
    //  <!-- // 2024/5/6 买一送一版 -- end -->
  };
  getFormItems() {
    const items = [];
    const triggerSku = this.dataset.triggerSku;
    const giftVariantId = this.dataset.giftVariantId;
    let shouldAddGift = false;
    let shouldItem = {};
    let careId = "";
    let ringId = "";
    let option1 = "";
    let option2 = "";
    this.checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        const variantId = checkbox.value;
        const quantity = checkbox.closest(".combo-item").querySelector("[data-quantity-input]").value;
        const sku = checkbox.dataset.sku;
        careId = checkbox.dataset?.careId || careId;
        if (checkbox.dataset?.isRing == "true") {
          ringId = checkbox.dataset?.ringId || ringId;
          option1 = checkbox.dataset?.option1 || option1;
          option2 = checkbox.dataset?.option2 || option2;
        }
        // console.log(checkbox.dataset, "checkbox.dataset");

        // console.log(careId, ringId, "checkbox.dataset");
        let data = {
          id: variantId,
          quantity: parseInt(quantity),
          properties: {
            _isRing: checkbox.dataset?.isRing == "true",
            _isCare: checkbox.dataset?.isCare == "true",
            _ringId: checkbox.dataset?.ringId,
            _productOption1: checkbox.dataset?.option1 || null,
            _productOption2: checkbox.dataset?.option2 || null,
            _careType: false,
            _careId: checkbox.dataset?.careId,
          },
        };
        items.push(data);

        if (sku === triggerSku) {
          shouldAddGift = true;
          if (shouldItem.quantity) {
            shouldItem.quantity += parseInt(quantity);
          } else {
            shouldItem = {
              id: variantId,
              sku: sku,
              quantity: parseInt(quantity),
            };
          }
        }
      }
    });
    items.map((item) => {
      if (item.properties._isCare) {
        item.properties._noPrmitEdit = true;
        item.properties._careType = true;
      }
      if (item.properties._isRing || item.properties._isCare) {
        item.properties._careId = careId;
        item.properties._ringId = ringId;
        item.properties._ShowCare = true;
        item.properties._productOption1 = option1;
        item.properties._productOption2 = option2;
      }
      if (!item.properties._isRing && !item.properties._isCare) {
        item.properties._careId = null;
      }
      return item;
    });
    // console.log(items, "items getFormItems");
    if (shouldAddGift && giftVariantId) {
      items.push({
        id: giftVariantId,
        quantity: shouldItem.quantity,
        properties: {
          _noPrmitEdit: true,
        },
      });
    }

    return items;
  }
}

if (!customElements.get("combo-products")) {
  customElements.define("combo-products", ComboProducts);
}

class ComboItem extends HTMLElement {
  constructor() {
    super();
    setTimeout(() => {
      this.variantTrigger = this.querySelector("[data-variant-popup-trigger]");
      this.dialog = this.querySelector(".variant-popup-dialog");
      this.dialogSubmit = this.querySelector(".variant-popup__footer button");
      this.init();
    }, 0);
  }

  init() {
    if (this.variantTrigger) {
      this.variantTrigger.addEventListener("click", this.handleVariantClick.bind(this));
    }

    if (this.dialog) {
      this.dialog.querySelector(".variant-popup__close").addEventListener("click", async () => {
        const comboProducts = this.closest("combo-products");
        await this.dialog.close();
        setTimeout(() => {
          const submitButton = comboProducts.querySelector('.combo-products__footer button[type="submit"]');
          submitButton.setAttribute("disabled", false);
          submitButton.removeAttribute("aria-busy", false);
        }, 50);
      });
    }
    if (this.dialogSubmit) {
      this.dialogSubmit.addEventListener("click", this.handleVariantSubmit.bind(this));
    }
  }
  handleVariantSubmit(event) {
    event.preventDefault();

    // 获取父级 combo-products 组件
    const comboProducts = this.closest("combo-products");

    if (comboProducts) {
      setTimeout(() => {
        comboProducts.updateTotalPrice();
      }, 1000);
    }
  }
  handleVariantClick(event) {
    event.preventDefault();
    if (this.dialog) {
      this.dialog.showModal();
    }
  }
}

if (!customElements.get("combo-item")) {
  customElements.define("combo-item", ComboItem);
}
